export default {
  listPhoneType: [],
  phoneType: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
